import * as React from 'react';
import moment from 'moment';

import type { EventElementProps } from './event-element-props.interface';

export const UnaddressedChange = ({ data }: EventElementProps) => {
  const unaddressedClassName = `${data.areDataEventsOn ? '' : 'hide-important'} addressed-box`;

  return (
    <div
      id={`UnaddressedChange-${data.id}`}
      className={unaddressedClassName}
    >
      <div className="container">
        <div className="content">
          <div className="addressed-text">
            {`${data.sender_tag} marked conversation as ${data.unaddressed ? 'Unaddressed' : 'Addressed'}`}
          </div>
          <div className="chat-timestamp">
            {data.origin && `via ${data.origin} - `}
            {moment(data.sent_at * 1000).format('L [AT] LT')}
          </div>
        </div>
      </div>
    </div>
  );
};
